// // src/hooks/usePlanAccess.js
// import { useContext } from 'react';
// import { AuthContext } from '../contexts/AuthContext';

// // ── Tiers por feature ──
// const TIERS_COM_BOLETO                = ['PRO', 'ENTERPRISE'];
// const TIERS_COM_CONTRATO              = ['ENTERPRISE'];
// const TIERS_COM_WHATSAPP              = ['ENTERPRISE'];
// const TIERS_COM_NFSE                  = ['ENTERPRISE'];
// const TIERS_COM_RELATORIOS            = ['PRO', 'ENTERPRISE'];
// const TIERS_COM_RELATORIOS_NOTIFICACAO = ['ENTERPRISE'];

// // ── Labels e cores para exibição ──
// export const PLAN_LABELS = {
//   BASIC:      'Básico',
//   PRO:        'Profissional',
//   ENTERPRISE: 'Empresarial',
// };

// export const PLAN_COLORS = {
//   BASIC:      '#6c757d',
//   PRO:        '#4361ee',
//   ENTERPRISE: '#f8961e',
// };

// // ── Registro central de features ──
// // Adicione aqui toda nova funcionalidade bloqueável
// export const FEATURES = {
//   boleto: {
//     label:        'Gateway de Pagamento (Boleto/PIX)',
//     description:  'Gere cobranças via Boleto automaticamente.',
//     requiredPlan: 'PRO',
//   },
//   contrato: {
//     label:        'Assinatura Digital de Contratos',
//     description:  'Envie contratos para assinatura digital via Autentique.',
//     requiredPlan: 'ENTERPRISE',
//   },
//   whatsapp: {
//     label:        'Notificações WhatsApp',
//     description:  'Dispare mensagens automáticas de cobrança via WhatsApp.',
//     requiredPlan: 'ENTERPRISE',
//   },
//   nfse: {
//     label:        'Emissão de NFS-e',
//     description:  'Emita notas fiscais de serviço direto do sistema.',
//     requiredPlan: 'ENTERPRISE',
//   },
//   relatorios: {
//     label:        'Relatórios Avançados',
//     description:  'Tenha acesso a relatórios detalhados dos equipamentos e veja o que te dá mais resultado!',
//     requiredPlan: 'PRO',
//   },
//   relatoriosNotificacao: {
//     label:        'Relatórios de Notificações Automáticas',
//     description:  'Acompanhe entregas, leituras e respostas das mensagens automáticas de WhatsApp e e-mail.',
//     requiredPlan: 'ENTERPRISE',
//   },
//   emailNotificacao: {
//   label:        'Notificações por E-mail',
//   description:  'Dispare e-mails automáticos de cobrança e lembretes para seus clientes.',
//   requiredPlan: 'ENTERPRISE',
// },
// };

// export function usePlanAccess() {
//   const { user } = useContext(AuthContext);
//   const tier = user?.plan?.tier ?? 'BASIC';

//   // ── Acessos (mantém retrocompatibilidade) ──
//   const hasBoletoAccess                = TIERS_COM_BOLETO.includes(tier);
//   const hasContratoAccess              = TIERS_COM_CONTRATO.includes(tier);
//   const hasWhatsappAccess              = TIERS_COM_WHATSAPP.includes(tier);
//   const hasNfseAccess                  = TIERS_COM_NFSE.includes(tier);
//   const hasRelatoriosAccess            = TIERS_COM_RELATORIOS.includes(tier);
//   const hasRelatoriosNotificacaoAccess = TIERS_COM_RELATORIOS_NOTIFICACAO.includes(tier);

//   // ── Helper genérico ──
//   const hasAccess = (featureKey) => {
//     const feature = FEATURES[featureKey];
//     if (!feature) return true;
//     const map = {
//       boleto:                hasBoletoAccess,
//       contrato:              hasContratoAccess,
//       whatsapp:              hasWhatsappAccess,
//       nfse:                  hasNfseAccess,
//       relatorios:            hasRelatoriosAccess,
//       relatoriosNotificacao: hasRelatoriosNotificacaoAccess,
//     };
//     return map[featureKey] ?? false;
//   };

//   return {
//     tier,
//     planLabel: PLAN_LABELS[tier] ?? tier,
//     planColor: PLAN_COLORS[tier] ?? '#6c757d',
//     // flags diretos
//     hasBoletoAccess,
//     hasContratoAccess,
//     hasWhatsappAccess,
//     hasNfseAccess,
//     hasRelatoriosAccess,
//     hasRelatoriosNotificacaoAccess,
//     // helper genérico
//     hasAccess,
//   };
// }



// src/hooks/usePlanAccess.js
import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

// ── Tiers por feature ──
const TIERS_COM_BOLETO                 = ['PRO', 'ENTERPRISE'];
const TIERS_COM_CONTRATO               = ['ENTERPRISE'];
const TIERS_COM_WHATSAPP               = ['ENTERPRISE'];
const TIERS_COM_NFSE                   = ['ENTERPRISE'];
const TIERS_COM_RELATORIOS             = ['PRO', 'ENTERPRISE'];
const TIERS_COM_RELATORIOS_NOTIFICACAO = ['ENTERPRISE'];
const TIERS_COM_EMAIL_NOTIFICACAO      = ['ENTERPRISE'];

// ── Labels e cores para exibição ──
export const PLAN_LABELS = {
  BASIC:      'Básico',
  PRO:        'Profissional',
  ENTERPRISE: 'Empresarial',
};

export const PLAN_COLORS = {
  BASIC:      '#6c757d',
  PRO:        '#4361ee',
  ENTERPRISE: '#f8961e',
};

// ── Registro central de features ──
// Adicione aqui toda nova funcionalidade bloqueável
export const FEATURES = {
  boleto: {
    label:        'Gateway de Pagamento (Boleto/PIX)',
    description:  'Gere cobranças via Boleto automaticamente.',
    requiredPlan: 'PRO',
  },
  contrato: {
    label:        'Assinatura Digital de Contratos',
    description:  'Envie contratos para assinatura digital via Autentique.',
    requiredPlan: 'ENTERPRISE',
  },
  whatsapp: {
    label:        'Notificações WhatsApp',
    description:  'Dispare mensagens automáticas de cobrança via WhatsApp.',
    requiredPlan: 'ENTERPRISE',
  },
  nfse: {
    label:        'Emissão de NFS-e',
    description:  'Emita notas fiscais de serviço direto do sistema.',
    requiredPlan: 'ENTERPRISE',
  },
  relatorios: {
    label:        'Relatórios Avançados',
    description:  'Tenha acesso a relatórios detalhados dos equipamentos e veja o que te dá mais resultado!',
    requiredPlan: 'PRO',
  },
  relatoriosNotificacao: {
    label:        'Relatórios de Notificações Automáticas',
    description:  'Acompanhe entregas, leituras e respostas das mensagens automáticas de WhatsApp e e-mail.',
    requiredPlan: 'ENTERPRISE',
  },
  emailNotificacao: {
    label:        'Notificações por E-mail',
    description:  'Dispare e-mails automáticos de cobrança e lembretes para seus clientes.',
    requiredPlan: 'ENTERPRISE',
  },
};

export function usePlanAccess() {
  const { user } = useContext(AuthContext);
  const tier = user?.plan?.tier ?? 'BASIC';

  // ── Acessos ──
  const hasBoletoAccess                = TIERS_COM_BOLETO.includes(tier);
  const hasContratoAccess              = TIERS_COM_CONTRATO.includes(tier);
  const hasWhatsappAccess              = TIERS_COM_WHATSAPP.includes(tier);
  const hasNfseAccess                  = TIERS_COM_NFSE.includes(tier);
  const hasRelatoriosAccess            = TIERS_COM_RELATORIOS.includes(tier);
  const hasRelatoriosNotificacaoAccess = TIERS_COM_RELATORIOS_NOTIFICACAO.includes(tier);
  const hasEmailNotificacaoAccess      = TIERS_COM_EMAIL_NOTIFICACAO.includes(tier);

  // ── Helper genérico ──
  const hasAccess = (featureKey) => {
    const feature = FEATURES[featureKey];
    if (!feature) return true;
    const map = {
      boleto:                hasBoletoAccess,
      contrato:              hasContratoAccess,
      whatsapp:              hasWhatsappAccess,
      nfse:                  hasNfseAccess,
      relatorios:            hasRelatoriosAccess,
      relatoriosNotificacao: hasRelatoriosNotificacaoAccess,
      emailNotificacao:      hasEmailNotificacaoAccess,
    };
    return map[featureKey] ?? false;
  };

  return {
    tier,
    planLabel: PLAN_LABELS[tier] ?? tier,
    planColor: PLAN_COLORS[tier] ?? '#6c757d',
    // flags diretos
    hasBoletoAccess,
    hasContratoAccess,
    hasWhatsappAccess,
    hasNfseAccess,
    hasRelatoriosAccess,
    hasRelatoriosNotificacaoAccess,
    hasEmailNotificacaoAccess,
    // helper genérico
    hasAccess,
  };
}
